import type { ReactNode } from 'react'
import { Link } from 'wouter'

/**
 * CoinsRubot logo: a gold rounded square with a black crown, next to the
 * wordmark («Coins» in white, «Rubot» in gold). One component for the header and
 * the footer, so desktop and mobile show the same mark — on phones it is simply
 * a little smaller.
 */

export function LogoMark({ size = 34 }: { size?: number }): ReactNode {
  return (
    <svg
      className="cr-logo-mark"
      width={size}
      height={size}
      viewBox="0 0 120 120"
      role="img"
      aria-label="CoinsRubot"
    >
      <defs>
        <linearGradient id="crGold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ffe389" />
          <stop offset="42%" stopColor="#f5c518" />
          <stop offset="100%" stopColor="#dda61a" />
        </linearGradient>
        <linearGradient id="crGloss" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.42" />
          <stop offset="55%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect x="3" y="3" width="114" height="114" rx="30" fill="url(#crGold)" />
      <rect x="3" y="3" width="114" height="114" rx="30" fill="url(#crGloss)" />
      <g fill="none" stroke="#131318" strokeWidth="7.5" strokeLinejoin="round" strokeLinecap="round">
        <path d="M33 77 L26 43 L46 57 L60 30 L74 57 L94 43 L87 77 Z" />
        <path d="M39 87 H81" />
      </g>
    </svg>
  )
}

export function LogoWordmark() {
  return (
    <span className="cr-wordmark">
      Coins<em>Rubot</em>
    </span>
  )
}

/** The full logo (mark + wordmark), linking home. */
export default function BrandLogo({ className = 'v2-brand' }: { className?: string }) {
  return (
    <Link href="/" className={className} aria-label="CoinsRubot — на главную">
      <LogoMark />
      <LogoWordmark />
    </Link>
  )
}
